export enum LoyaltyEventAction {
    LOYALTY_LOADMORE_TEXT = 'Load More',
    LOYALTY_OFFER_SELECTED = 'loyalty offer selected',
    LOYALTY_OFFER_REMOVED = 'loyalty offer removed',
    LOYALTY_REWARD_SELECTED = 'reward selected',
    LOYALTY_REWARD_REMOVED = 'reward removed',
    LOYALTY_ONLINE_TEXT = 'Online Purchase Order',
    LOYALTY_BENEFITS_TEXT = 'Benefits',
    LOYALTY_POINTS_TEXT = 'Points',
    LOYALTY_REWARDS_TEXT = 'Rewards',
    LOYALTY_EVENT_PAGE = 'my account page'
}
